let refreshingPromise: Promise<string> | null = null;

export function singleFlightRefresh(fn: () => Promise<string>): Promise<string> {
  if (!refreshingPromise) {
    refreshingPromise = fn().finally(() => {
      refreshingPromise = null;
    });
  }
  return refreshingPromise;
}
